// extracted by mini-css-extract-plugin
export default {"cta":"EG-z","disabled":"FG-z"};